import {
  ROLE_CLEAR_SELECTED,
  ROLE_CREATE_SUCCESS,
  ROLE_LIST_SUCCESS,
  ROLE_ONE_SUCCESS,
  ROLE_UPDATE_FILTER,
} from 'src/actions/role.acction';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

const initState = {
  filter: {
    name: '',
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: {}
}

const roleReducer = (state = initState, action) => {
  switch (action.type) {
    case ROLE_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }

    case ROLE_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }

    case ROLE_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }

    case ROLE_CREATE_SUCCESS: {
      return {
        ...state,
        list: {
          data: action.data
        }
      }
    }

    case ROLE_CLEAR_SELECTED: {
      return {
        ...state,
        selected: {}
      }
    }
    default: {
      return state;
    }
  }
}
export default roleReducer